import { Box } from '@mui/material';
import { arenaToast } from 'src/components/arenaSnackbar';

/**
 * Shown while desktop Chromium's permission prompt is open: its "Remember my
 * decision" defaults to "until I close this site", and that allow lapses the
 * moment the tab closes, which is exactly when a push is meant to arrive.
 */
const showRememberForeverHint = () =>
  arenaToast(
    <>
      In the browser prompt, set Remember my decision to{' '}
      <Box component="span" sx={{ color: '#FFE27A', fontWeight: 800 }}>
        Forever
      </Box>
      , or notifications stop once you close Abekus.
    </>,
    { tone: 'warning', label: 'One quick step', duration: 60000 },
  );

export default showRememberForeverHint;
